import React, { Component } from 'react';
import config from '../config';
import NavBar from '../components/NavBar';
import '../css/Default.css';
import 'react-table/react-table.css';
import { asyncForEach, getParameterByName, populateForm, onBlurCurrency, dateSql, now } from '../Utils';
import swal from '@sweetalert/with-react';

const inputParsers = {
	date(input) {
		const [ month, day, year ] = input.split('/');
		return `${year}-${month}-${day}`;
	},
	uppercase(input) {
		return input.toUpperCase();
	},
	number(input) {
		return parseFloat(input);
	}
};

class LiquidarContasPagar extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			combos: [],
			recebido: 0,
			automatico: false,
			filter: [],
			selected: {
				cidadeComerc: []
			},
			filterChanged: '',
			edit: false,
			data: []
		};
		this.submitData = this.submitData.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleClean = this.handleClean.bind(this);
		this.selectFornecedor = this.selectFornecedor.bind(this);
		this.selectSubclasse = this.selectSubclasse.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.handleBack = this.handleBack.bind(this);
		this.validateData = this.validateData.bind(this);
	}

	async componentDidMount() {
		//Busca valores para combo de filtro
		//Situação
		await fetch(config.protocol + '://' + config.server + ':' + config.portBackend + '/api/getFornecedores')
			.then((r) => r.json())
			.then(async (r) => {
				let comboFornecedores = this.state.combos;
				await asyncForEach(r, async (item) => {
					let fornecedores = {
						type: 'fornecedores',
						display: item.razao_social,
						value: item.pk_for
					};
					await comboFornecedores.push(fornecedores);
				});
				this.setState({ combos: this.state.combos });
			});

		await fetch(config.protocol + '://' + config.server + ':' + config.portBackend + '/api/getSubclasses')
			.then((r) => r.json())
			.then(async (r) => {
				let comboSubclasses = this.state.combos;
				await asyncForEach(r, async (item) => {
					let subclasse = {
						type: 'subclasses',
						display: item.descricao,
						value: item.pk_sub
					};
					await comboSubclasses.push(subclasse);
				});
				this.setState({ combos: this.state.combos });
			});

		//Testar se é edição
		let query = {};
		query.pk = Number(getParameterByName('pk'));

		if (query.pk > 0) {
			fetch(
				config.protocol +
					'://' +
					config.server +
					':' +
					config.portBackend +
					'/api/getContasPagar?pk=' +
					query.pk
			)
				.then((r) => r.json())
				.then(async (r) => {
					if (typeof r[0] === 'undefined') {
						swal('Erro!', 'Código não encontrado.', 'error').then(r=>window.location.href = '/apergs/contas-pagar')
					} else {
						if (r[0].valor - r[0].liquidado <= 0){
							swal('Erro!', 'Registro já está totalmente liquidado.', 'error').then(r=>window.location.href = '/apergs/contas-pagar')
							// window.location.href = '/apergs/contas-pagar';
						}

						let form = document.getElementById('registroContasPagar');
						let selectedFornecedor = this.state.combos.filter((item) => {
							return item.type === 'fornecedores' && item.value === r[0].fk_for;
						});
						let selectedSubclasse = this.state.combos.filter((item) => {
							return item.type === 'subclasses' && item.value === r[0].fk_sub;
						});
						this.setState({
							selected: {
								subclasse: selectedSubclasse[0],
								fornecedor: selectedFornecedor[0]
							}, pendente: r[0].valor - r[0].liquidado
						});
						r[0].pendente = (r[0].valor - r[0].liquidado).toFixed(2).replace('.', ',');;
						r[0].data_venc = dateSql(r[0].data_venc);
						r[0].data_emis = dateSql(r[0].data_emis);
						r[0].data_liq = dateSql(r[0].data_liq);
						this.setState({ recebido: Number(r[0].liquidado)  });
						r[0].liquidado = (Number(r[0].liquidado))
							.toFixed(2)
							.replace('.', ',');
						r[0].valor = r[0].valor.toFixed(2).replace('.', ',');
						// $('#valor_pendente').val(r[0].liquidado);
						console.log(r[0]);
						populateForm(form, r[0]);
					}
				});
			this.setState({ edit: true });
		}
	}

	handleChange(e) {
		//Popula inputs do filtro
		e.preventDefault();
		let target = e.target;
		let value = target.type === 'checkbox' ? target.checked : target.value;
		let name = target.name;
		let reg = this.state.filter;
		reg[name] = value;
		this.setState({
			filter: reg
		});
	}

	handleClean(e) {
		//Limpa o filtro
	}

	async modelingData(data) {
		//Trata os campos
	}

	handleSave(e) {
		e.preventDefault();
		swal({
			title: 'Atenção!',
			text: 'Deseja registrar o pagamento?',
			buttons: [ 'Sim', 'Não' ]
		}).then((result) => {
			if (!result) this.submitData(e);
		});
	}

	handleBack(e) {
		e.preventDefault();
		swal({
			dangerMode: true,
			title: 'Atenção!',
			text: 'Ao voltar, todas as alterações serão descartadas. Confirma?',
			buttons: [ 'Sim', 'Não' ]
		}).then((result) => {
			if (!result) window.history.back();
		});
	}

	validateData(data, tit) {
		let valid = { isValid: true };
		//Consistências

		//Data de Emissão
		if (!data.get('data_liq')) {
			return { isValid: false, title: 'Campo inválido!', message: 'Verifique o campo DATA DO PAGAMENTO.' };
		}

		//Valor
		if (Number(data.get('valor').replace(',','.')) === 0) {
			return { isValid: false, title: 'Campo inválido!', message: 'Verifique o campo VALOR PAGO.' };
		}

		//Valor > pendente
		if (Number(data.get('valor').replace(',','.')) > this.state.pendente) {
			return { isValid: false, title: 'Campo inválido!', message: 'VALOR PAGO não pode ser maior que o valor pendente da conta.' };
		}


		console.log(valid);
		//Retorna resultado
		return valid;
	}

	submitData(e) {
		e.preventDefault();
		//Pega valores do form
		const form = document.getElementById('registroBaixaTit');
		const data = new FormData(form);
		const formTit = document.getElementById('registroContasPagar');
		const tit = new FormData(formTit);
		 

		let validate = this.validateData(data, tit);

		if (!validate.isValid) {
			swal(validate.title, validate.message, 'error');
			throw validate;
		}


		//Trata valores conforme data-parse dos inputs
		for (let name of data.keys()) {
			const input = form.elements[name];
			//console.log(input)
			//Rejeita type = undefined (radio inputs)
			if (typeof (input || []).type !== 'undefined') {
				const parserName = input.dataset.parse;
				if (parserName) {
					const parser = inputParsers[parserName];
					const parsedValue = parser(data.get(name));
					data.set(name, parsedValue);
				}
			}
		}

		//Converte FormData em JSON
		var object = {};
		data.forEach(function(value, key) {
			object[key] = value;
		});

		object.data_lancto = now();
		object.valor = Number(object.valor.replace(',', '.'))
		object.fk_tit = Number(getParameterByName('pk'))

		let liquidou = this.state.pendente === object.valor
		console.log(liquidou)
		var json = JSON.stringify(object);



		//Post no server
		//Inserir
		fetch(config.protocol + '://' + config.server + ':' + config.portBackend + '/api/novoBaixaTit?liquidou='+String(liquidou), {
			method: 'POST',
			headers: {
				'Content-type': 'application/json'
			},
			body: json
		})
			.then((r) => r.json())
			.then((r) => {
				console.log(r);
				if (r.message === 'Success!') {
					swal('Inclusão realizada', 'Pagamento incluído com sucesso!', 'success').then((result) => {
						window.history.back();
					});
				} else {
					swal('Inclusão não realizada', 'Pagamento não foi incluído. Verifique os campos.', 'error');
				}
			});
	}

	selectFornecedor(item) {
		this.setState({
			selected: {
				fornecedor: item
			}
		});
	}

	selectSubclasse(item) {
		this.setState({
			selected: {
				subclasse: item
			}
		});
	}


	render() {
		console.log(this.state.combos);
		return (
			<div className="boxSite colorSettings">
				{/***************** Barra de Navegação *******************/}
				<div className="boxNavBar">
					<NavBar selected="ContasPagar" />
				</div>
				{/***************** Tela do WebSite *******************/}
				<div className="boxTela">
					{/*********************** Header ***********************/}
					<div className="boxHeader">
						<h3 className="headerCadastro">Liquidar Conta a Pagar</h3>
					</div>
					{/*********************** Campos ***********************/}
					<div style={{ paddingBottom: '30px' }}>
						<div style={{ marginLeft: '30px', marginRight: '30px', paddingBottom: '30px' }}>
							<form id="registroContasPagar" name="registroContasPagar">
									<div className="row">
										<div className="col-sm-4">
											<label>Fornecedor:</label>
											<input
												type="text"
												id="razao_social"
												name="razao_social"
												className="form-control"
												data-parse='uppercase'
												disabled
											/>
										</div>
										<div className="col-sm-2">
											<label>Data Emissão:</label>
											<input type="date" name="data_emis" className="form-control" disabled/>
										</div>
										<div className="col-sm-2">
											<label>Data Vencimento:</label>
											<input type="date" name="data_venc" className="form-control" disabled/>
										</div>
										<div className="col-sm-2">
											<label>Valor (R$):</label>
											<input
												type="text"
												id="valor"
												name="valor"
												className="form-control"
												onBlur={(e) => {
													onBlurCurrency(e);
												}}
												disabled
											/>
										</div>
										<div className="col-sm-2">
											<label>Valor Liquidado(R$):</label>
											<input
												type="text"
												id="liquidado"
												name="liquidado"
												className="form-control"
												onBlur={(e) => {
													onBlurCurrency(e);
												}}
												disabled
												
											/>
										</div>
										<div className="col-sm-2">
											<label>Valor Pendente(R$):</label>
											<input
												type="text"
												id="pendente"
												name="pendente"
												className="form-control"
												onBlur={(e) => {
													onBlurCurrency(e);
												}}
												disabled
												
											/>
										</div>
										<div className="col-sm-2">
											<label>Subclasse:</label>
											<input
												type="text"
												id="descricaosub"
												name="descricaosub"
												className="form-control"
												data-parse='uppercase'
												disabled
											/>
										</div>
									</div>
							</form>
							<form id="registroBaixaTit" name="registroBaixaTit" onSubmit={this.submitData}>
								<div style={{ height: 'auto', marginTop: '30px' }}>
									<div className="boxRegistro">
										<div style={{paddingTop: '5px'}}>
											<div className="row">
												<div className="col-sm-2">
													<label>Data do Pagamento:</label>
													<input type="date" name="data_liq" className="form-control"/>
												</div>
												<div className="col-sm-2" style={{ width: '140px' }}>
													<label>Valor pago (R$):</label>
													<input
														type="text"
														id="valor"
														name="valor"
														className="form-control"
														onBlur={(e) => {
															onBlurCurrency(e);
														}}
													/>
												</div>
												<div className="col-sm-12">
													<label>Observações:</label>
													<textarea
														type="text"
														name="observacao"
														data-parse="uppercase"
														className="form-control"
														style={{ height: '100px' }}
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
								<br/>
								<div className="buttonsCadastro">
									<button className="buttonSalvar" onClick={this.handleSave}>
										Salvar
									</button>
									<button className="buttonVoltar" onClick={this.handleBack}>
										Voltar
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default LiquidarContasPagar;
